/* global describe test expect */
import express from 'express';
import request from 'supertest';
import AsyncRouter from '.';

describe('Post Endpoints', () => {
  const middleware = (req, res, next) => {
    req.userId = 123;
    return next();
  };
  const middlewareReqId = (req, res, next) => {
    req.reqId = 123;
    return next();
  };
  test('test 1', async () => {
    const app = express();
    const router = AsyncRouter();
    router.get(
      '/test',
      middleware,
      async (req, res) => {
        return res.send(200);
      },
    );
    app.use('/', router);
    const res = await request(app).get('/test');
    expect(res.statusCode).toEqual(200);
    // expect(res.body).toHaveProperty('post')
  });
  test('test 2', async () => {
    const app = express();
    const router = AsyncRouter();
    router.all(
      '/test',
      (req, res, next) => {
        console.log('middleware');
        next();
      },
      async (req, res) => {
        return res.send(200);
      },
    );
    app.use('/', router);
    const res = await request(app).get('/test');
    expect(res.statusCode).toEqual(200);
    // expect(res.body).toHaveProperty('post')
  });
  test('test 3', async () => {
    const app = express();
    const router = AsyncRouter();
    router.use(
      '/test',
      (req, res, next) => {
        console.log('middleware');
        next();
      },
      (req, res, next) => {
        console.log('middleware2');
        next();
      },
      async (req, res) => {
        return res.send(200);
      },
    );
    app.use('/', router);
    const res = await request(app).get('/test');
    expect(res.statusCode).toEqual(200);
    // expect(res.body).toHaveProperty('post')
  });
});
